export default {
  /** OT Publisher's config */
  publisherConfig(state, getters, rootState, rootGetters) {
    return {
      publishAudio: state.publisherAudioEnabled,
      publishVideo: state.publisherVideoEnabled,
      audioSource: rootState.calls.devices.selectedAudioSource,
      videoSource: rootState.calls.devices.selectedVideoSource,
      showControls: false,
      mirror: false,
      height: "100%",
      width: "100%",
      ...rootGetters["calls/connectivity/connectivityPublisherConfig"]
    };
  },
  /** OT Subscriber's config */
  subscriberConfig(state, getters, rootState, rootGetters) {
    return {
      testNetwork: true,
      subscribeToAudio: state.subscriberAudioEnabled,
      subscribeToVideo: true,
      showControls: false,
      audioVolume: state.subscriberAudioLevel,
      height: "100%",
      width: "100%",
      ...rootGetters["calls/connectivity/connectivitySubscriberConfig"]
    };
  }
};
